import {
  Close,
  Forward,
  RemoveRedEye,
  RepeatOutlined,
  Assignment
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import {
  assignPrimeProductToMember,
  getPrimePinMemberList,
  getPrimeStockProductList,
  purchasePrimeProductToMember,
  revokePrimeProductFromMember,
  getPrimeMemberAssignEligibility
} from "src/api/primestockapi";
import { notification } from "src/utils/messages";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import MemberHistoryModal from "./memberHistoryModal";
import PinReportModal from "./pinReportModal";
import { CSVLink } from "react-csv";
import RemoveFromEligibleModal from "./removeFromEligibleModal";
import CustomLoader from "src/components/CustomLoader";
import { canAssignStock, canRevokeStock, getLoggedInUser } from "src/utils/stockPermission";

export default function MemberList() {
  const { state } = useLocation();
  const approveModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  const navigate = useNavigate();
  const csvLinkRef = React.useRef();

  const loginUser = getLoggedInUser();
  const canAssign = canAssignStock(loginUser);
  const canRevoke = canRevokeStock(loginUser);

  const [tabValue, setTabValue] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exporting, setExporting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [assignPage, setAssignPage] = useState(1);
  const [purchaseMemberPage, setPurchaseMemberPage] = useState(1);
  const [allMemberPage, setAllMemberPage] = useState(1);
  const [rowPerPage, setRowsPerPage] = useState(10);
  const [assignRowPerPage, setAssignRowsPerPage] = useState(10);
  const [purchaseMemberRowPerPage, setPurchaseMemberRowsPerPage] = useState(10);
  const [allMemberRowPerPage, setAllMemberRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [eligibleMemberCounter, setEligibleMemberCounter] = useState(0);
  const [assignMemberCounter, setAssignMemberCounter] = useState(0);
  const [purchaseMemberCounter, setPurchaseMemberCounter] = useState(0);
  const [allMemberCounter, setAllMemberCounter] = useState(0);
  const [memberData, setMemberData] = useState([]);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [removeEligibleModal, setRemoveEligibleModal] = useState(false);
  const [memberListHistoryModal, setMemberListHistoryModal] = useState(false);
  const [reAssignConfirmationModal, setreAssignConfirmationModal] = useState(false);
  const [revokeConfirmationModal, setRevokeConfirmationModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [pinReportModal, setPinReportModal] = useState(false);
  const [eligibility, setEligibility] = useState(null);
  const [revokeReason, setRevokeReason] = useState("");

  // Prime has no city or chapter tier, so only these filters remain.
  const [filtereddata, setFilteredData] = useState({
    search: "",
    start_date: null,
    e_date: null,
    activeMemberSearchType: 1
  });

  const memberStatus = [
    { label: "All", value: 0 },
    { label: "Active", value: 1 },
    { label: "Deactive", value: 2 }
  ];

  const toggleMemberListHistoryModal = () => setMemberListHistoryModal(!memberListHistoryModal);
  const toggleRemoveEligibleModal = () => setRemoveEligibleModal(!removeEligibleModal);
  const togglePinReportModal = () => setPinReportModal(!pinReportModal);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    const updatedFilter = newValue === 0
      ? { ...filtereddata, activeMemberSearchType: 1 }
      : filtereddata;
    if (newValue === 0) {
      setFilteredData(updatedFilter);
    }
    handleGetWelcomekitMemberList(newValue, updatedFilter);
  };

  const expo_eligibleMemberColumn = [
    { label: "Member Name", key: "m_name" },
    { label: "Member Email", key: "m_email_id" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Eligible Date", key: "eligibality_date" }
  ];

  const expo_assignMemberColumn = [
    { label: "Member Name", key: "m_name" },
    { label: "Member Email", key: "m_email_id" },
    { label: "Assign Name", key: "assign_name" },
    { label: "Assign Date", key: "assign_date" },
    { label: "Contact No", key: "mobile_no" }
  ];

  const expo_purchaseMemberColumn = [
    { label: "Member Name", key: "m_name" },
    { label: "Member Email", key: "m_email_id" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Assign Date", key: "assign_date" },
    { label: "Amount", key: "amount" }
  ];

  const expo_allMemberColumn = [
    { label: "Member Name", key: "m_name" },
    { label: "Member Email", key: "m_email_id" },
    { label: "Contact No", key: "mobile_no" }
  ];

  const handleExportCSV = async () => {
    setExporting(true);
    await handleGetWelcomekitMemberList(tabValue, filtereddata, 1);
  };

  const handleGetWelcomekitMemberList = async (value, filterData, isExport = 0, overridePId = 0, overridePType = null, overridePApId = null) => {
    const activePType = overridePType ?? selectedProduct?.p_type ?? state.p_type;
    const activePId = overridePId || selectedProduct?.p_id || state.p_id;
    const activePApId = overridePApId ?? selectedProduct?.p_a_p_id ?? state.p_a_p_id;
    // Nothing to query until a product is resolved - stay quiet instead of
    // firing a request the backend will reject.
    if (!activePId) {
      setMemberData([]);
      return;
    }
    let data = {
      type:
        activePType != 0
          ? value === 0
            ? 1
            : value === 1
              ? 2
              : value === 2
                ? 3
                : 4
          : value === 0
            ? 3
            : 4,
      p_id: activePId,
      page:
        value == 0
          ? page
          : value === 1
            ? assignPage
            : value === 2
              ? purchaseMemberPage
              : allMemberPage,
      search: filterData?.search,
      start_date: filterData?.start_date,
      end_date: filterData?.e_date,
      status: value === 0 ? 1 : filterData?.activeMemberSearchType,
      is_export: isExport,
      per_page:
        value == 0
          ? rowPerPage
          : value === 1
            ? assignRowPerPage
            : value === 2
              ? purchaseMemberRowPerPage
              : allMemberRowPerPage
    };
    if (activePType == 1) {
      data.p_a_p_id = activePApId;
      data.p_type = 1;
    } else {
      data.p_type = activePType;
    }
    setIsLoading(true);
    const resp = await getPrimePinMemberList(data);
    setIsLoading(false);

    if (isExport) {
      setExportData(resp?.data?.data || []);
      setTimeout(() => {
        csvLinkRef.current.link.click(); // auto download
        setExporting(false);
      }, 100);
      return;
    }
    const rows = resp?.data?.data || [];
    const seen = new Set();
    const dedupedRows = rows.filter((row) => {
      const id = row?.m_id;
      if (id == null) return true;
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
    setMemberData(dedupedRows);
    setTotalRows(resp?.data?.counter || 0);
    setEligibleMemberCounter(resp?.data?.member_eligibility_counter || 0);
    setAssignMemberCounter(resp?.data?.member_assign_counter || 0);
    setPurchaseMemberCounter(resp?.data?.purchased_member_counter || 0);
    setAllMemberCounter(resp?.data?.all_member_counter || 0);
    setEligibleMemberCounter(resp.data?.member_eligibility_counter);
    setAssignMemberCounter(resp.data?.member_assign_counter);
    setPurchaseMemberCounter(resp.data?.purchased_member_counter);
    setAllMemberCounter(resp.data?.all_member_counter);
  };

  // Refetch when the resolved product arrives. The product lookup is async, so
  // without this the first render queries with an undefined p_id and the table
  // stays empty until the user paginates.
  useEffect(() => {
    if (!selectedProduct?.p_id) return;
    const initialTab =
      state?.tab != undefined && state.tab !== null ? parseInt(state.tab) : tabValue;
    setTabValue(initialTab);
    const reset =
      filtereddata.activeMemberSearchType === 0 ? { ...filtereddata, activeMemberSearchType: 1 } : filtereddata;
    setFilteredData(reset);
    setPage(1);
    setAssignPage(1);
    setPurchaseMemberPage(1);
    setAllMemberPage(1);
    handleGetWelcomekitMemberList(initialTab, reset);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct?.p_id]);

  useEffect(() => {
    handleGetWelcomekitMemberList(tabValue, filtereddata);
  }, [
    page,
    assignPage,
    rowPerPage,
    assignRowPerPage,
    purchaseMemberPage,
    purchaseMemberRowPerPage,
    allMemberPage,
    allMemberRowPerPage
  ]);

  useEffect(async () => {
    const products = await getPrimeStockProductList({});
    const list = products?.data || [];
    setProductList(list);
    if (state?.p_id && list.length > 0) {
      const match = list.find((p) => p.p_id == state.p_id);
      if (match) {
        setSelectedProduct({ label: match.p_name, value: match.p_id, ...match });
      }
    }
  }, []);

  const conditionalRowStyles = [
    {
      when: (row) => row?.is_purchased === 1,
      style: {
        backgroundColor: "#86f2baff", // light green
        color: "#000"
      }
    }
  ];

  const eligibleMemberColumns = [
    {
      name: "Member Name",
      selector: (row) => <span title={row?.m_name}>{row?.m_name}</span>,
      sortable: false,
      width: "300px"
    },
    {
      name: "Member Email",
      selector: (row) => <span title={row?.m_email_id}>{row?.m_email_id}</span>,
      sortable: false,
      width: "200px"
    },
    {
      name: "Contact No",
      selector: (row) => row?.mobile_no,
      sortable: false,
      width: "150px"
    },
    {
      name: "Eligible Date",
      selector: (row) => row?.eligibality_date,
      sortable: false,
      width: "150px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: false,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Assign Product">
            <IconButton
              disabled={!canAssign}
              onClick={async () => {
                if (!canAssign) return;
                setRowData(row);
                const resp = await getPrimeMemberAssignEligibility({
                  m_id: row.m_id,
                  p_id: selectedProduct?.p_id || state?.p_id
                });
                if (resp?.status == 1) setEligibility(resp.data);
                setConfirmationModal(true);
              }}
            >
              <Forward color="warning" />
            </IconButton>
          </Tooltip>

          <Tooltip title="View History">
            <IconButton
              onClick={() => {
                setRowData({
                  ...row,
                  p_id: selectedProduct?.p_id || state?.p_id,
                  p_name: selectedProduct?.p_name || state?.p_name
                });
                toggleMemberListHistoryModal();
              }}
            >
              <RemoveRedEye color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Not Eligible">
            <IconButton
              disabled={!canAssign}
              onClick={() => {
                if (!canAssign) return;
                setRowData(row);
                setRemoveEligibleModal(true);
              }}
            >
              <Close color="error" />
            </IconButton>
          </Tooltip>

          {(selectedProduct?.p_type == 1 || state?.p_type == 1) && (
            <Tooltip title="Pin Report">
              <IconButton
                onClick={() => {
                  setRowData({
                    ...row,
                    p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id,
                    p_name: selectedProduct?.p_name || state?.p_name
                  });
                  togglePinReportModal();
                }}
              >
                <Assignment color="primary" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )
    }
  ];

  const assignMemberColumns = [
    {
      name: "Member Name",
      selector: (row) => <span title={row?.m_name}>{row?.m_name}</span>,
      sortable: false,
      width: "300px"
    },
    {
      name: "Member Email",
      selector: (row) => <span title={row?.m_email_id}>{row?.m_email_id}</span>,
      sortable: false,
      width: "200px"
    },
    {
      name: "Assign Name",
      selector: (row) => row?.assign_name,
      sortable: false,
      width: "130px"
    },
    {
      name: "Assign Date",
      selector: (row) => row?.assign_date,
      sortable: false,
      width: "150px"
    },
    {
      name: "Eligible Date",
      selector: (row) => row?.eligibality_date,
      sortable: false,
      width: "150px"
    },
    {
      name: "Contact No",
      selector: (row) => row?.mobile_no,
      sortable: false,
      width: "150px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: false,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Purchase Product">
            <IconButton
              disabled={!canAssign}
              onClick={async () => {
                if (!canAssign) return;
                setRowData(row);
                const resp = await getPrimeMemberAssignEligibility({
                  m_id: row.m_id,
                  p_id: selectedProduct?.p_id || state?.p_id
                });
                if (resp?.status == 1) setEligibility(resp.data);
                setreAssignConfirmationModal(true);
              }}
            >
              <RepeatOutlined color="warning" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View History">
            <IconButton
              onClick={() => {
                setRowData({
                  ...row,
                  p_id: selectedProduct?.p_id || state?.p_id,
                  p_name: selectedProduct?.p_name || state?.p_name
                });
                toggleMemberListHistoryModal();
              }}
            >
              <RemoveRedEye color="primary" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Revoke">
            <IconButton
              disabled={!canRevoke}
              onClick={() => {
                if (!canRevoke) return;
                setRevokeReason("");
                setRowData(row);
                setRevokeConfirmationModal(true);
              }}
            >
              <Close color="error" />
            </IconButton>
          </Tooltip>

          {(selectedProduct?.p_type == 1 || state?.p_type == 1) && (
            <Tooltip title="Pin Report">
              <IconButton
                onClick={() => {
                  setRowData({
                    ...row,
                    p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id,
                    p_name: selectedProduct?.p_name || state?.p_name
                  });
                  togglePinReportModal();
                }}
              >
                <Assignment color="primary" />
              </IconButton>
            </Tooltip>
          )}
        </>
      )
    }
  ];

  const purchaseMemberColumns = [
    {
      name: "Member Name",
      selector: (row) => <span title={row?.m_name}>{row?.m_name}</span>,
      sortable: false,
      width: "300px"
    },
    {
      name: "Member Email",
      selector: (row) => <span title={row?.m_email_id}>{row?.m_email_id}</span>,
      sortable: false,
      width: "200px"
    },
    {
      name: "Contact No",
      selector: (row) => row?.mobile_no,
      sortable: false,
      width: "150px"
    },
    {
      name: "Assign Date",
      selector: (row) => row?.assign_date,
      sortable: false,
      width: "150px"
    },
    {
      name: "Amount",
      selector: (row) => (parseFloat(row?.amount) > 0 ? `₹${row.amount}` : "-"),
      sortable: false,
      width: "120px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: false,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Purchase Product">
            <IconButton
              disabled={!canAssign}
              onClick={async () => {
                if (!canAssign) return;
                setRowData(row);
                const resp = await getPrimeMemberAssignEligibility({
                  m_id: row.m_id,
                  p_id: selectedProduct?.p_id || state?.p_id
                });
                if (resp?.status == 1) setEligibility(resp.data);
                setreAssignConfirmationModal(true);
              }}
            >
              <RepeatOutlined color="warning" />
            </IconButton>
          </Tooltip>

          <Tooltip title="View History">
            <IconButton
              onClick={() => {
                setRowData({
                  ...row,
                  p_id: selectedProduct?.p_id || state?.p_id,
                  p_name: selectedProduct?.p_name || state?.p_name
                });
                toggleMemberListHistoryModal();
              }}
            >
              <RemoveRedEye color="primary" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const allMemberColumns = [
    {
      name: "Member Name",
      selector: (row) => <span title={row?.m_name}>{row?.m_name}</span>,
      sortable: false,
      width: "300px"
    },
    {
      name: "Member Email",
      selector: (row) => <span title={row?.m_email_id}>{row?.m_email_id}</span>,
      sortable: false,
      width: "200px"
    },
    {
      name: "Contact No",
      selector: (row) => row?.mobile_no,
      sortable: false,
      width: "150px"
    },
    {
      name: "Action",
      wrap: true,
      sortable: false,
      width: "200px",
      selector: (row) => (
        <>
          <Tooltip title="Purchase Product">
            <IconButton
              disabled={!canAssign}
              onClick={async () => {
                if (!canAssign) return;
                setRowData(row);
                const resp = await getPrimeMemberAssignEligibility({
                  m_id: row.m_id,
                  p_id: selectedProduct?.p_id || state?.p_id
                });
                if (resp?.status == 1) setEligibility(resp.data);
                setreAssignConfirmationModal(true);
              }}
            >
              <RepeatOutlined color="warning" />
            </IconButton>
          </Tooltip>

          <Tooltip title="View History">
            <IconButton
              onClick={() => {
                setRowData({
                  ...row,
                  p_id: selectedProduct?.p_id || state?.p_id,
                  p_name: selectedProduct?.p_name || state?.p_name
                });
                toggleMemberListHistoryModal();
              }}
            >
              <RemoveRedEye color="primary" />
            </IconButton>
          </Tooltip>
        </>
      )
    }
  ];

  const CustomBadges = ({ counter }) => {
    return (
      <Box
        sx={{
          background: "linear-gradient(135deg, #034766 0%, #02364d 100%)",
          color: "#fff",
          padding: "2px 8px",
          borderRadius: "6px",
          fontSize: "0.75rem",
          fontWeight: 700,
          ml: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
      >
        {counter != undefined ? counter : 0}
      </Box>
    );
  };

  return (
    <>
      <Container>
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={12} lg={4}>
              <Stack spacing={0.5}>
                <Box sx={{ minWidth: 280 }}>
                  <Select
                    placeholder="Select Product..."
                    value={selectedProduct}
                    onChange={(e) => {
                      setSelectedProduct(e);
                      setPage(1);
                      setAssignPage(1);
                      setPurchaseMemberPage(1);
                      setAllMemberPage(1);
                      handleGetWelcomekitMemberList(tabValue, filtereddata, 0, e?.p_id || 0, e?.p_type, e?.p_a_p_id);
                    }}
                    options={productList.map((p) => ({
                      label: p.p_name,
                      value: p.p_id,
                      p_id: p.p_id,
                      p_name: p.p_name,
                      p_type: p.p_type,
                      p_a_p_id: p.p_a_p_id,
                      p_price: p.p_price
                    }))}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: "#034766",
                        minHeight: "44px",
                        boxShadow: "0 2px 8px rgba(3,71,102,0.08)",
                        "&:hover": { borderColor: "#02364d" }
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#999",
                        fontWeight: 500,
                        fontSize: "0.95rem"
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color: "#034766",
                        fontWeight: 700,
                        fontSize: "1rem"
                      }),
                      menu: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.12)"
                      }),
                      option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        fontWeight: 500,
                        color: isSelected ? "#fff" : "#034766",
                        backgroundColor: isSelected ? "#034766" : isFocused ? "#e8f0fe" : "#fff"
                      }),
                      dropdownIndicator: (base) => ({
                        ...base,
                        color: "#034766",
                        "&:hover": { color: "#02364d" }
                      }),
                      clearIndicator: (base) => ({
                        ...base,
                        color: "#034766",
                        "&:hover": { color: "#02364d" }
                      })
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="subtitle1" sx={{ color: "text.secondary", fontWeight: 500 }}>
                    Members List
                  </Typography>
                  <div style={{ width: "4px", height: "4px", borderRadius: "50%", backgroundColor: "#ccc" }} />
                  <Typography variant="caption" sx={{ color: "text.disabled", fontWeight: 500, textTransform: "uppercase" }}>
                    Stock Management
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            <Grid item xs={12} lg={8}>
              <Grid container spacing={1.5} justifyContent="flex-end">
                <Grid item xs={12} sm={6} md={3} lg={2}>
                  <Stack spacing={0.5}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary", ml: 0.2 }}>Member Status</Typography>
                    <Select
                      isDisabled={tabValue === 0}
                      value={
                        filtereddata.activeMemberSearchType == 0
                          ? { value: 0, label: "All" }
                          : filtereddata.activeMemberSearchType == 1
                            ? { value: 1, label: "Active" }
                            : { value: 2, label: "Deactive" }
                      }
                      onChange={(e) => {
                        setFilteredData({ ...filtereddata, activeMemberSearchType: e.value });
                      }}
                      options={memberStatus}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Stack spacing={0.5}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary", ml: 0.2 }}>Start Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                      <DatePicker
                        size="small"
                        sx={{ width: "100%" }}
                        name="s_date"
                        inputFormat="dd/MM/yyyy"
                        value={filtereddata.start_date != null ? moment(filtereddata.start_date, "DD-MM-YYYY") : null}
                        onChange={(newDate) => {
                          setFilteredData({
                            ...filtereddata,
                            start_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                          });
                        }}
                        renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <Stack spacing={0.5}>
                    <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary", ml: 0.2 }}>End Date</Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                      <DatePicker
                        size="small"
                        sx={{ width: "100%" }}
                        name="e_date"
                        inputFormat="dd/MM/yyyy"
                        value={filtereddata.e_date != null ? moment(filtereddata.e_date, "DD-MM-YYYY") : null}
                        onChange={(newDate) => {
                          setFilteredData({
                            ...filtereddata,
                            e_date: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                          });
                        }}
                        renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Grid>

              <Grid container spacing={1.5} justifyContent="flex-start" sx={{ mt: 1 }}>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="off"
                    type="text"
                    placeholder="Search by name, email or mobile..."
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        height: "38px"
                      }
                    }}
                    name="search_text"
                    value={filtereddata.search}
                    onChange={(e) => {
                      setFilteredData({ ...filtereddata, search: e.target.value });
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Stack direction="row" spacing={1} justifyContent="flex-start">
                    <Button
                      variant="contained"
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                      onClick={() => {
                        handleGetWelcomekitMemberList(tabValue, filtereddata);
                      }}
                      sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3, height: "38px", backgroundColor: "#034766", "&:hover": { backgroundColor: "#02364d" } }}
                    >
                      Search
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        const resetData = {
                          ...filtereddata,
                          search: "",
                          start_date: null,
                          e_date: null,
                          activeMemberSearchType: 1
                        };
                        setFilteredData(resetData);
                        handleGetWelcomekitMemberList(tabValue, resetData);
                      }}
                      sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3, height: "38px" }}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      color="inherit"
                      onClick={() => navigate(-1)}
                      sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, px: 3, height: "38px", backgroundColor: "#6c757d", color: "#fff", "&:hover": { backgroundColor: "#5a6268" } }}
                    >
                      Back
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, mt: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#034766",
                height: 3,
                borderRadius: "3px 3px 0 0"
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                minWidth: 100,
                color: "text.secondary",
                "&.Mui-selected": {
                  color: "#034766"
                }
              }
            }}
          >
            {(selectedProduct?.p_type ?? state.p_type) != 0 && (
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Eligible Member</span>
                    <CustomBadges counter={eligibleMemberCounter} />
                  </Box>
                }
              />
            )}
            {(selectedProduct?.p_type ?? state.p_type) != 0 && (
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>Assign Member</span>
                    <CustomBadges counter={assignMemberCounter} />
                  </Box>
                }
              />
            )}
            <Tab
              label={
                <Box display="flex" alignItems="center" gap={0.2}>
                  <span>Purchase Member</span>
                  <CustomBadges counter={purchaseMemberCounter} />
                </Box>
              }
            />
            {(selectedProduct?.p_type ?? state.p_type) != 1 && (
              <Tab
                label={
                  <Box display="flex" alignItems="center" gap={0.2}>
                    <span>All Member</span>
                    <CustomBadges counter={allMemberCounter} />
                  </Box>
                }
              />
            )}
          </Tabs>
        </Box>
        <Card>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
              pb: 0
            }}
          >
            <Button
              variant="contained"
              disabled={exporting}
              onClick={handleExportCSV}
              sx={{
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#034766",
                "&:hover": { backgroundColor: "#02364d" }
              }}
            >
              {exporting ? "Exporting..." : "Export CSV"}
            </Button>

            <CSVLink
              ref={csvLinkRef}
              data={exportData}
              headers={
                tabValue === 0
                  ? expo_eligibleMemberColumn
                  : tabValue === 1
                    ? expo_assignMemberColumn
                    : tabValue === 2
                      ? expo_purchaseMemberColumn
                      : expo_allMemberColumn
              }
              filename="Member_Report.csv"
              style={{ display: "none" }}
            />
          </Box>
          {tabValue === 0 ? (
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPage(p)}
              onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
              columns={(selectedProduct?.p_type ?? state.p_type) != 0 ? eligibleMemberColumns : purchaseMemberColumns}
              data={memberData != null ? memberData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          ) : tabValue === 1 ? (
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              conditionalRowStyles={conditionalRowStyles}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setAssignPage(p)}
              onChangeRowsPerPage={(newPerPage) => setAssignRowsPerPage(newPerPage)}
              columns={(selectedProduct?.p_type ?? state.p_type) != 0 ? assignMemberColumns : allMemberColumns}
              data={memberData != null ? memberData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          ) : tabValue === 2 ? (
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              conditionalRowStyles={conditionalRowStyles}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setPurchaseMemberPage(p)}
              onChangeRowsPerPage={(newPerPage) => setPurchaseMemberRowsPerPage(newPerPage)}
              columns={purchaseMemberColumns}
              data={memberData != null ? memberData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          ) : (
            <DataTable
              pagination
              highlightOnHover
              paginationServer
              conditionalRowStyles={conditionalRowStyles}
              paginationTotalRows={totalRows}
              onChangePage={(p) => setAllMemberPage(p)}
              onChangeRowsPerPage={(newPerPage) => setAllMemberRowsPerPage(newPerPage)}
              columns={allMemberColumns}
              data={memberData != null ? memberData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          )}
        </Card>

        {/* Free assign */}
        <Modal open={confirmationModal} onClose={() => setConfirmationModal(false)}>
          <Box sx={approveModalStyle}>
            <Typography variant="h6" textAlign="center">
              {eligibility?.requires_purchase
                ? "Are you sure you want to Purchase this Product?"
                : "Are you sure you want to assign this Product?"}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={async () => {
                  const res = eligibility?.requires_purchase
                    ? await purchasePrimeProductToMember({
                        m_id: rowData.m_id,
                        p_id: selectedProduct?.p_id || state?.p_id,
                        p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id || 0,
                        p_type: selectedProduct?.p_type ?? state?.p_type,
                        u_id: loginUser?.u_id,
                        u_name: loginUser?.name,
                        date: moment().format("DD-MM-YYYY"),
                        eligible_date: rowData.eligibality_date
                      })
                    : await assignPrimeProductToMember({
                        m_id: rowData.m_id,
                        p_id: selectedProduct?.p_id || state?.p_id,
                        p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id || 0,
                        p_type: selectedProduct?.p_type ?? state?.p_type,
                        u_id: loginUser?.u_id,
                        u_name: loginUser?.name,
                        date: moment().format("DD-MM-YYYY"),
                        eligible_date: rowData.eligibality_date
                      });
                  let notify = notification({
                    type: res.status == 0 ? "error" : "success",
                    message: res.message
                  });
                  notify();
                  if (res.status == 1) {
                    handleGetWelcomekitMemberList(tabValue, filtereddata);
                  }
                  setConfirmationModal(false);
                }}
              >
                Yes, {eligibility?.requires_purchase ? "Purchase" : "Assign"}
              </Button>
              <Button variant="outlined" onClick={() => setConfirmationModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Purchase */}
        <Modal open={reAssignConfirmationModal} onClose={() => setreAssignConfirmationModal(false)}>
          <Box sx={approveModalStyle}>
            <Typography variant="h6" textAlign="center">
              Are you sure you want to Purchase this Product?
            </Typography>
            <Typography
              variant="h6"
              textAlign="center"
              sx={{ color: "primary.main", fontWeight: 600 }}
            >
              Price: ₹{eligibility?.amount ?? selectedProduct?.p_price ?? 0}
            </Typography>
            <Typography variant="body2" textAlign="center" color="text.secondary" mt={1}>
              {eligibility?.reason}
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                className="btn btn-primary"
                onClick={async () => {
                  const res = await purchasePrimeProductToMember({
                    m_id: rowData.m_id,
                    p_id: selectedProduct?.p_id || state?.p_id,
                    p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id || 0,
                    p_type: selectedProduct?.p_type ?? state?.p_type,
                    u_id: loginUser?.u_id,
                    u_name: loginUser?.name,
                    date: moment().format("DD-MM-YYYY"),
                    eligible_date: rowData.eligibality_date
                  });
                  let notify = notification({
                    type: res.status == 0 ? "error" : "success",
                    message: res.message
                  });
                  notify();
                  if (res.status == 1) {
                    handleGetWelcomekitMemberList(tabValue, filtereddata);
                  }
                  setreAssignConfirmationModal(false);
                }}
              >
                Yes, Purchase
              </Button>
              <Button variant="outlined" onClick={() => setreAssignConfirmationModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>

        {/* Revoke */}
        <Modal open={revokeConfirmationModal} onClose={() => setRevokeConfirmationModal(false)}>
          <Box sx={approveModalStyle}>
            <Typography variant="h6" textAlign="center">
              Are you sure you want to Revoke this Product?
            </Typography>
            <Typography variant="body2" textAlign="center" color="text.secondary" mt={1} mb={2}>
              The quantity will be returned to the Prime stock pool and the assignment will be
              marked as revoked.
            </Typography>
            <TextField
              fullWidth
              size="small"
              label="Reason"
              value={revokeReason}
              onChange={(e) => setRevokeReason(e.target.value)}
            />
            <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                onClick={async () => {
                  const res = await revokePrimeProductFromMember({
                    m_p_a_id: rowData.mpa_id || rowData.m_p_a_id,
                    u_id: loginUser?.u_id,
                    u_name: loginUser?.name,
                    date: moment().format("DD-MM-YYYY"),
                    reason: revokeReason
                  });
                  let notify = notification({
                    type: res.status == 0 ? "error" : "success",
                    message: res.message
                  });
                  notify();
                  if (res.status == 1) {
                    handleGetWelcomekitMemberList(tabValue, filtereddata);
                  }
                  setRevokeConfirmationModal(false);
                }}
              >
                Yes, Revoke
              </Button>
              <Button variant="outlined" onClick={() => setRevokeConfirmationModal(false)}>
                Cancel
              </Button>
            </Stack>
          </Box>
        </Modal>
      </Container>
      {memberListHistoryModal && (
        <MemberHistoryModal
          memberListHistoryModal={memberListHistoryModal}
          toggleMemberListHistoryModal={toggleMemberListHistoryModal}
          rowData={rowData}
        />
      )}
      {removeEligibleModal && (
        <RemoveFromEligibleModal
          removeEligibleModal={removeEligibleModal}
          toggleRemoveEligibleModal={toggleRemoveEligibleModal}
          rowData={rowData}
          p_id={selectedProduct?.p_id || state?.p_id}
          p_a_p_id={selectedProduct?.p_a_p_id || state?.p_a_p_id}
          p_type={selectedProduct?.p_type || state?.p_type}
          handleGetWelcomekitMemberList={handleGetWelcomekitMemberList}
          tabValue={tabValue}
          filtereddata={filtereddata}
        />
      )}
      {pinReportModal && (
        <PinReportModal
          open={pinReportModal}
          onClose={togglePinReportModal}
          rowData={{
            ...rowData,
            p_a_p_id: selectedProduct?.p_a_p_id || state?.p_a_p_id,
            p_name: selectedProduct?.p_name || state?.p_name
          }}
        />
      )}
    </>
  );
}
